export const NotFound = (): JSX.Element => <div>Not Found</div>;
